import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PageHeaderState {
	title: string;
}

const initialState: PageHeaderState = {
	title: ""
};

const pageHeaderSlice = createSlice({
	name: "pageHeader",
	initialState,
	reducers: {
		setPageHeader(state, action: PayloadAction<PageHeaderState>) {
			state.title = action.payload.title;
		},
		clearPageHeader(state) {
			state.title = "";
		}
	}
});

export const { setPageHeader, clearPageHeader } = pageHeaderSlice.actions;
export const { reducer } = pageHeaderSlice;
